import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

export interface ILocalLoginProps {}

export class LocalLogin extends React.Component<ILocalLoginProps> {
  public render() {
    sessionStorage.setItem('isLocalLogin', 'true');
    return (
      <Switch>
        <Redirect to="/" />
      </Switch>
    );
  }
}

export class ClearLocalLogin extends React.Component<ILocalLoginProps> {
  public render() {
    sessionStorage.setItem('isLocalLogin', 'false');
    return (
      <Switch>
        <Redirect to="/" />
      </Switch>
    );
  }
}
